import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { UtilService } from 'src/app/util/util.service';
import { CustomersService } from '../../customers.service';

@Component({
  selector: 'customer-profile-object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.scss']
})
export class CustomerProfileObjectComponent implements OnInit {

  private _data: any;

  @Input()
  set data(value: any) {   // this is setter for booleanCheck input.
    this._data = value;
  }

  constructor(
    private utilSvc: UtilService,
    private custSvc: CustomersService,
  ) { }

  ngOnInit(): void {
    //console.log("objectComponent", "data", this._data);
  }

  get data() {
    return this._data;
  }

  formatProfileValue(value: any){
    return this.custSvc.formatData(this._data, value);
  }

  prepareField(field: any){
    //console.log("prepareField", field);
    let f = cloneDeep(field);
    f.value = this.data.value[field.id];
    return f;
  }

  prepareObject(field: any, value: any){
    //console.log("prepareObject", field, value, this.data);
    let f = cloneDeep(field);
    f.value = value[field.id];
    return f;
  }

}
